import gql from 'graphql-tag';

const INCREMENT_LESSON_HABIT = gql`
  mutation {
    increment_lesson_habit {
      rate
      growth_rate
      lesson_objective
      lesson_count
      remaining_lesson_count
      exclude_lesson
      remaining_days
    }
  }
`;

const INCREMENT_LESSON_HABIT_MSB = gql`
  mutation incrementLessonHabit{
    incrementLessonHabit {
      rate
      growth_rate
      lesson_objective
      lesson_count
      remaining_lesson_count
      exclude_lesson
      remaining_days
    }
  }
`;

export {
  INCREMENT_LESSON_HABIT,
  INCREMENT_LESSON_HABIT_MSB
};
